import { useEffect, useState } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { FileDoc } from '@/types/file'

export interface FileRecord extends FileDoc {
  id: string
}

interface FilesState {
  files: FileRecord[]
  loading: boolean
  error: string | null
}

/** Realtime list of a project's stage-evidence files (all stages). */
export function useProjectFiles(projectId: string): FilesState {
  const [state, setState] = useState<FilesState>({ files: [], loading: true, error: null })

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'projects', projectId, 'files'),
      (snapshot) => {
        const files = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...(docSnap.data() as FileDoc),
        }))
        setState({ files, loading: false, error: null })
      },
      (error) => setState({ files: [], loading: false, error: error.message }),
    )
    return unsubscribe
  }, [projectId])

  return state
}
